// extracted by mini-css-extract-plugin
export default {"expires":"nDhkiFZ3zU2MIHZcZKtw"};